module.exports = __webpack_public_path__ + "static/img/third2_1_1_active.7360ab15.jpg";